module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTDBr/zNv/zJv/zJu/zJv/zJu/zJv/zJv/zNu/zBw/zNv/7D/UFkAAAALdFJOUwAhv6Z42WBG75AQycuBsgAAAQNJREFUKM+10r9uwjAQBnCHpkIwBXUoKAtqRqZKiA5ZIsSA1J0BFmZYqnbsI3jsUpWpb9C6mIC+l8Ou/x0hI3xDhp+sy93ZjF0uUefc2mMO+VQ9mENndqpTmHxRjC1CJkSfnWIesOkRh6C3QfHidU2073VBtCRlObCvFI4hvrlMzCDS6Q22LBeuutMGdkTtHNFnnapuqWaGU+i60o9tOn5XXU2Akev61+lJysrCTHY1yq1ukAWUqfq1To5VWE/ZsJsYIOl6LWL8mT0KFrnDW9aGMGdV+TtbVd3EwGytV6jPm0ax1C0Jcs33H9nwfwOtx0u+Uh+ied17YDzoT9DXB5+CXTFHDSLsubRHcvUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/zzsy-1.png
// module id = D7Rn
// module chunks = 0